import React from 'react';
import EmptyState from './EmptyState';
import Pagination from './Pagination';

const TaskList = ({ 
  tasks, 
  totalCount = 0,
  loading, 
  isLoadingMore,
  currentPage,
  totalPages,
  onPageChange,
  renderTaskItem,
  error,
  onRefresh
}) => {
  if (loading) {
    return (
      <div className="loading-state">Loading tasks...</div>
    );
  }

  if (error) {
    return (
      <div className="error-state">
        <div className="error-message">{error}</div>
        {onRefresh && (
          <button 
            className="refresh-button" 
            onClick={onRefresh}
            aria-label="Refresh tasks"
          >
            Refresh
          </button>
        )}
      </div>
    );
  }

  if (tasks.length === 0) {
    return <EmptyState onRefresh={onRefresh} />;
  }

  // ADD_BEGIN: Display tasks count at top of list
  const tasksCountElement = (
    <div className="tasks-count" aria-live="polite">
      {tasks.length} / {totalCount} {totalCount === 1 ? 'Task' : 'Tasks'}
    </div>
  );
  // ADD_END

  return (
    <div className="tasks-list-container">
      {/* Inject tasks count element */}
      {tasksCountElement}
      <div className="tasks-list">
        {tasks.map(renderTaskItem)}
        {isLoadingMore && (
          <div className="loading-more">
            <div className="loading-spinner"></div>
            <span>Loading more tasks...</span>
          </div>
        )}
      </div>
      
      <Pagination 
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        isLoading={isLoadingMore}
      />
    </div>
  );
};

export default TaskList; 